import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
// ✅ ADD THIS LINE BELOW TO MAKE THE TOGGLE WORK
import "bootstrap/dist/js/bootstrap.bundle.min.js"; 

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);